import axios from "axios";
import { NewsListConfig, NewsListDisplayMode } from "../../sitemap/services/SitemapService";
import { KeyValuePair } from "@/helpers/Interfaces";
import { ResourceConfidential } from "@/modules/logito/office/services/OfficeDocuments";
import { PagerContract } from "@/helpers/Pager";
import { merge } from "lodash";
import { DateTime } from "luxon";

export class NewsListService
{
    private static instance: NewsListService;

    private constructor() {}

    public static getInstance(): NewsListService
    {
        if (!NewsListService.instance)
        {
            NewsListService.instance = new NewsListService();
        }

        return NewsListService.instance;
    }

    public static async getNewsList(license: string, sitemapId: string, filter: Record<string, unknown>, pager: PagerContract): Promise<NewsListData>
    {
        return (await axios.get<NewsListData>(`simple-query/${license}/series/newslist?sitemapId=${sitemapId}`, { params: merge({}, filter, pager) })).data;
    }

    public static getConfig(newsListConfig: NewsListSerie): NewsListConfig
    {
        return newsListConfig.config;
    }

    public static async getViewConfig(license: string, sitemapId: string): Promise<NewsListViewConfig>
    {
        return (await axios.get<NewsListViewConfig>(`simple-query/${license}/config/newslist?sitemapId=${sitemapId}`)).data;
    }

    public static async getAction(license: string, sitemapId: string): Promise<any>
    {
        return (await axios.get<any>(`simple-query/${license}/${sitemapId}/actions`)).data;
    }

    public static getTraitConfig(trait: KeyValuePair, newsListConfig: NewsListSerie): KeyValuePair | null
    {
        const config = NewsListService.getConfig(newsListConfig);

        if (!config) return null;

        if (Array.isArray(config.descriptionFields) && config)
        {
            return config.descriptionFields.find((field: KeyValuePair) => field.key == trait.key);
        }

        return null;
    }

    public static mapTraitHeaderValue(trait: KeyValuePair, newsListConfig: NewsListSerie): string
    {
        return NewsListService.getTraitConfig(trait, newsListConfig)?.value ?? '';
    }

    public static getTraitType(trait: KeyValuePair, newsListConfig: NewsListSerie): string
    {
        const conf = NewsListService.getTraitConfig(trait, newsListConfig) as any;

        return conf.type;
    }
}

export interface NewsListData {
    config: NewsListEntryConfig;
    series: NewsListSerie[];
    totalRows: number;
}

export interface NewsListSerie {
    config: NewsListConfig;
    name: string;
    color: string;
    documents: Document[];
}

export interface Document {
    description: KeyValuePair[];
    license: string;
    publicId: string;
    shortDescription: string;
    title: string;
    photo: ResourceConfidential | null;
    publicationDate: DateTime;
}

export interface NewsListEntryConfig {
    displayMode: NewsListDisplayMode;
    width: number;
    height: number;
    useFilters: boolean;
}

export interface NewsListViewConfig {
    config: NewsListEntryConfig;
    series: NewsListSerie[];
}
